import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SECTORS } from "../data/content";
import { PAGE_SEO } from "../data/seoContent";
import SEO, { breadcrumbSchema } from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";

export default function Sectors() {
  const crumbs = [{ name: "Home", path: "/" }, { name: "Sectors", path: "/sectors" }];
  return (
    <div data-testid="page-sectors">
      <SEO {...PAGE_SEO.sectors} schema={breadcrumbSchema(crumbs)} />
      <section className="bg-[#0A0F1C] text-white pt-16 pb-24 lg:pt-24 lg:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="mb-8"><Breadcrumb items={crumbs} theme="dark" /></div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-6">Sectors</p>
          <h1 className="font-display text-5xl lg:text-7xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            Built for the estates we <span className="gs-gradient-text">serve.</span>
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            Every sector carries its own legislative exposure and operational profile. Our consultants tailor scope, reporting and cadence to the realities of your estate.
          </p>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SECTORS.map((s) => (
            <Link key={s.slug} to="/contact" className="group block border border-slate-200 hover:border-slate-900 transition-colors" data-testid={`sector-card-${s.slug}`}>
              <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                <img src={s.image} alt={s.name} loading="lazy" decoding="async" width="800" height="450" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <p className="font-display text-xl font-semibold text-slate-900">{s.name}</p>
                  <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-slate-900 transition-colors" />
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">{s.copy}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
